import React from 'react';
import { ProbabilityForecastDataContent } from './types';

interface ProbabilityForecastSummaryProps {
  data: unknown;
  config: Record<string, unknown>;
}

const ProbabilityForecastSummary: React.FC<ProbabilityForecastSummaryProps> = ({ data }) => {
  const content = data as ProbabilityForecastDataContent | undefined;
  const probUp = content?.probUp;

  if (typeof probUp !== 'number') {
    return <span className="text-neutral-300">—</span>;
  }

  const pct = Math.round(probUp * 100);
  const cls =
    pct >= 55
      ? 'bg-success-500 text-white'
      : pct <= 45
        ? 'bg-danger-500 text-white'
        : 'bg-neutral-400 text-white';

  return (
    <span className={`inline-block min-w-[40px] text-center px-2 py-0.5 text-xs font-bold rounded-full ${cls}`}>
      {pct}%
    </span>
  );
};

export default ProbabilityForecastSummary;
